import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import { ChipDownContainer } from "@similarweb/ui-components";
import type {
    IGenderID } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/getGenderFilterItems";
import {
    getGenderFilterItems,
    items as genderItems,
} from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/getGenderFilterItems";
import type { setter } from "app/UtilitiesAndConstants/types/setter";
import type { IAgeBucketIDs } from "app/UtilitiesAndConstants/types/age";
import { allTrackers } from "app/services/track/track";
import { items as ageItems } from "./getAgeFilterItems";

interface IGenderFilter {
    genderID: IGenderID;
    setGenderID: setter<IGenderID>;
    ageBucketIDs: IAgeBucketIDs;
}

export const GenderFilter: FC<IGenderFilter> = (props) => {
    const { genderID, setGenderID, ageBucketIDs } = props;
    const onGenderClick = (genderItem) => {
        setGenderID(genderItem.id);
        const ages = ageItems
            .filter(({ id }) => id !== "all" && ageBucketIDs.includes(id))
            .map(({ textKey }) => textKey)
            .join();
        const eventName = ageBucketIDs.length ? `Gender/${genderItem.id}/${ages}` : `Gender/${genderItem.id}`;
        allTrackers.trackEvent("Drop down", "apply", eventName);
    };
    const onCloseGenderClick = (a) => {
        setGenderID(undefined);
    };
    const isAllAgesSelected = genderID === "all" || ageBucketIDs.length >= 6;
    const onToggle = (isOpen) => {
        if (isOpen) {
            allTrackers.trackEvent("Drop down", "open", "Gender");
        }
    };
    return (
        <ChipDownContainer
            width={170}
            hasSearch={false}
            selectedIds={genderID && { [genderID]: true }}
            selectedText={genderID && translate(genderItems.find(({ id }) => id === genderID).textKey)}
            enabledTooltip={false}
            buttonText={translate("demographics.user.based.compare.table.filters.gender.female")}
            onClick={onGenderClick}
            onCloseItem={onCloseGenderClick}
            onToggle={onToggle}
            noResultsMessage={translate("dropdown.no.results")}
        >
            {getGenderFilterItems(isAllAgesSelected)}
        </ChipDownContainer>
    );
};
